import axios from 'axios';

class Mailer {
  sendContract = (props: any) =>
    axios.post(
      '/mailer/client-interest-in-yard',
      {
        yardId: props.yardId,
      },
      { params: { notLoading: true } },
    );

  sendSignUp = (props: any) => axios.post('/mailer/client-interest-buy-container', props);
}
export const mailerService = new Mailer();
